/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { FleetManagementPage } from '@/pages/FleetManagement/FleetManagementPage';

export function FleetManagementRoute() {
  return <FleetManagementPage />;
}
